
































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import OrganizationIcon from '@/components/common/OrganizationIcon.vue';
import AccountIcon from '@/components/common/AccountIcon.vue';

@Component({
  components: {
    OrganizationIcon,
    AccountIcon
  }
})
export default class JoinProjectTab extends Vue {
  private techniqueRating: number = 3;
  private communicationRating: number = 3;
  private understandingRating: number = 3;
  private techniqueRating2: number = 0;
  private communicationRating2: number = 0;
  private understandingRating2: number = 0;
  private scrollY: number = 0;
  private scrollReferencePoint: number = 100;
  private isScrollLower: boolean = false;
  private organizationAvatarSize: number = 30;
  private organizationAvatarColor: string = '#fa5f7e';

  private mounted() {
    const targetElement = document.getElementById('scrollBarTarget');
    if (targetElement) {
      targetElement.addEventListener('scroll', this.handleScroll);
    }
  }
  private handleScroll() {
    const targetElement = document.getElementById('scrollBodyTarget');
    if (targetElement) {
      const clientRect = targetElement.getBoundingClientRect();
      this.scrollY = clientRect.top;
    }
    if (this.scrollY < this.scrollReferencePoint) {
      this.isScrollLower = true;
    } else {
      this.isScrollLower = false;
    }
  }
}
